import Card from "../../common/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import formatter from "../../../helpers/formatter";
import { Link } from "react-router";

export default function ShortStatCard({ title, value, icon, isPublished }) {
  return (
    <Link
      to={`/ai-video/list${
        isPublished !== undefined ? `?isPublished=${isPublished}` : ""
      }`}
    >
      <Card className="hover:shadow-lg hover:bg-empower-500 hover:text-white transition-all duration-300">
        <Card.Body>
          <div className="flex items-center justify-between">
            <div className="text-lg font-semibold ">{title}</div>
            <FontAwesomeIcon icon={icon} size="lg" />
          </div>
          <div className="text-4xl font-bold ">{formatter.number(value)}</div>
        </Card.Body>
      </Card>
    </Link>
  );
}
